
window.upcartOnCartLoaded = () => {
  // console.log('hiii loaded')

  fetch('/cart.js', {
      method: 'GET',
      cache: 'no-store'
  })
  .then(response => response.json())
  .then(cart => {

    // console.log('item count',cart.item_count);

    if(cart.item_count > 0){
      let enable_shipping = sessionStorage.getItem('enable_shipping');
      // console.log(cartData); // Logs the stored cart data or null if not found
      if(!enable_shipping){
        // console.log('hii not')
        const shadowHost = document.querySelector('#upCart'); // Replace with the actual shadow host selector
        if (shadowHost && shadowHost.shadowRoot) {
            const cart_popup = shadowHost.shadowRoot.querySelector('#CartPopup');
          
          if(cart_popup){
            const shipping_switch = cart_popup.querySelector('.upcart-footer .upcart-addons .upcart-addons-toggle .styles_ToggleSwitch__');
            if(shipping_switch){
              shipping_switch.click();
              sessionStorage.setItem('enable_shipping','yes');
            }
          }
        } else {
            console.error('Shadow root not found');
        }

      }
    }
  })
  .catch(error => console.error('Error:', error));
}